import {Outlet} from "react-router-dom";
import api from "./api";
import {useEffect} from "react";

const GuardedRoute = () => {
  useEffect(() => {
    const isVerified = async () => {
      return await api.get('/v1/auth/verify');
    }
    isVerified();
  }, []);

  return <Outlet />;
}

export default GuardedRoute;
